import { render, staticRenderFns } from "./FantasyAtTheBay.vue?vue&type=template&id=37f63f0c&scoped=true&"
import script from "./FantasyAtTheBay.vue?vue&type=script&lang=js&"
export * from "./FantasyAtTheBay.vue?vue&type=script&lang=js&"
import style0 from "./FantasyAtTheBay.vue?vue&type=style&index=0&id=37f63f0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f63f0c",
  null
  
)

export default component.exports